var $33aba885fd306c4d$exports = {};
$33aba885fd306c4d$exports = {
  "pending": "\u05DE\u05DE\u05EA\u05D9\u05DF \u05DC"
};
export { $33aba885fd306c4d$exports as default };